/// <amd-module name="DistributedTask/Client/Linking" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

namespace Routes {
    export const AgentPools = "ms.vss-build-web.agent-pools-route";
}

export interface IDistributedLinkingService extends IVssService {
    getAgentPoolUrl(poolId: number, agentId?: number): string;
}

class DistributedLinkingService extends VssService implements IDistributedLinkingService {

    public getAgentPoolUrl(poolId: number, agentId?: number): string {
        const routeValues: { [key: string]: string } = {};
        let url = routeUrl(this.pageContext, Routes.AgentPools, routeValues);
        url += `?poolId=${poolId}`;
        if (agentId) {
            url += `&agentId=${agentId}`;
        }

        return url;
    }
}

Services.add("IDistributedLinkingService", { serviceFactory: DistributedLinkingService });
